<template>
    <div
        class="device-content"
        :class="{ 'device-content--left': position === 'left', 'device-content--right': position === 'right' }"
    >
        <img :src="device.image" class="device device--left" />
        <div class="title">
            <span v-text="brand"></span> <b style="white-space: nowrap">{{ name }}</b>

            <transition name="win">
                <div class="bars__winner" v-if="winner && currentStep === device.propGroups.length">
                    WINS
                </div>
            </transition>
        </div>
        <div class="steps">
            <transition name="fade" appear mode="out-in">
                <template v-for="(step, index) in device.propGroups">
                    <div class="bars" :key="step.name" v-if="index === currentStep">
                        <portal to="step" v-if="position === 'left'">
                            <transition name="slidedown" mode="in-out" appear>
                                <div class="badge">
                                    <span>{{ step.name }}</span>
                                </div>
                            </transition>
                        </portal>
                        <transition-group name="slide" appear>
                            <div class="bar-content" v-for="field in step.properties" :key="field.name">
                                <div class="bar-content__title">
                                    <h2>{{ field.name }}</h2>
                                    <img v-if="field.value === true" src="/ok.svg" />
                                    <img v-if="field.value === false" src="/cancel.svg" />
                                    <h3 v-if="field.value !== true && field.value !== false">
                                        {{ field.value }}{{ field.unit }}
                                    </h3>
                                </div>
                                <div class="bar" v-if="field.value !== true && field.value !== false && field.percent">
                                    <span data-width="76%" :style="{ width: `${field.percent}%` }"></span>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </template>
            </transition>

            <transition name="svg" appear>
                <div class="bars bars--widget" v-if="currentStep === device.propGroups.length">
                    <div class="bars__points">
                        <h1 style="font-size: 100px; line-height: 1; margin: 0">{{ device.score }}</h1>
                        <div style="font-size: 45px; color: #666">Points</div>
                    </div>
                    <portal to="step" v-if="position === 'left'">
                        <transition name="slidedown" mode="in-out" appear>
                            <div class="badge">
                                <span>Results</span>
                            </div>
                        </transition>
                    </portal>
                    <portal to="stats">
                        <transition name="svg" appear>
                            <div class="svg-container" v-html="vectorCode" v-if="position === 'left' || true"></div>
                        </transition>
                    </portal>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { wait } from "../utils";
export default {
    props: ["position", "device", "winner", "vector"],
    name: "Device",
    data() {
        return {
            currentStep: -1
        };
    },
    methods: {
        async start() {
            this.currentStep++;

            for (let i = 0; i < this.device.propGroups.length; i++) {
                await wait(7500);
                //await wait(3000);
                this.currentStep++;
            }

            await wait(7500);
            //await wait(1000);

            this.$parent.end();
        }
    },
    computed: {
        vectorCode() {
            const filter = `<defs>
                <filter x="-0.3" y="-0.3" width="1.6" height="1.6" id="caption">

                   <feFlood flood-color="white" result="temp"/>
                    <feGaussianBlur in="temp" stdDeviation="10" result="blur" />
                  <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
                  <feComposite in="SourceGraphic" in2="goo" operator="atop"/>
              </filter>

            </defs>`;

            return this.vector.replace("</svg>", `${filter}</svg>`);
        },
        brand() {
            return this.device.name.split(" ")[0];
        },
        name() {
            return this.device.name.substr(this.brand.length + 1);
        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
    transition: opacity 0.5s;
    transform: translateY(0%);
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateY(30%);
}
.slidedown-enter-active,
.slidedown-leave-active {
    transition: all 0.5s;
    transform: translate(-50%, 0%) !important;
}
.slidedown-enter,
.slidedown-leave-to {
    opacity: 0;
    transform: translate(-50%, -30%) !important;
}
.svg-enter-active,
.svg-leave-active {
    transition: all 1.5s;
    transition-delay: 1s;
    opacity: 1;
    transform: translateY(0%) !important;
}
.svg-enter,
.svg-leave-to {
    opacity: 0;
    transform: translateY(50%) !important;
}
.win-enter-active,
.win-leave-active {
    transition: all 0.8s cubic-bezier(0.53, 0.7, 0.67, 1.97);
    transition-delay: 2.5s;
    opacity: 1;
    transform: scale(1) !important;
}
.win-enter,
.win-leave-to {
    opacity: 0;
    transform: scale(0.1) !important;
}

@keyframes jackInTheBox {
    from {
        opacity: 0;
        transform: scale(0.1) rotate(30deg);
        transform-origin: center bottom;
    }

    50% {
        transform: rotate(-10deg);
    }

    70% {
        transform: rotate(3deg);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
